import React from 'react';
import { Plus, Flame, Timer, Activity, TrendingUp } from 'lucide-react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
const data = [{
  name: 'Mon',
  minutes: 45
}, {
  name: 'Tue',
  minutes: 30
}, {
  name: 'Wed',
  minutes: 0
}, {
  name: 'Thu',
  minutes: 60
}, {
  name: 'Fri',
  minutes: 45
}, {
  name: 'Sat',
  minutes: 90
}, {
  name: 'Sun',
  minutes: 0
}];
export function Exercise() {
  return <div className="p-8 max-w-7xl mx-auto space-y-8" data-id="element-195">
      {/* Header */}
      <div className="flex justify-between items-end" data-id="element-196">
        <div data-id="element-197">
          <h1 className="text-3xl font-bold text-slate-900" data-id="element-198">Exercise</h1>
          <p className="text-slate-500 mt-1" data-id="element-199">Track your workouts</p>
        </div>
        <button className="flex items-center gap-2 bg-slate-800 hover:bg-slate-900 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors" data-id="element-200">
          <Plus className="w-4 h-4" data-id="element-201" /> Log
        </button>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-202">
        <div className="bg-gradient-to-br from-orange-500 to-red-500 rounded-2xl p-6 text-white shadow-lg shadow-orange-200" data-id="element-203">
          <TrendingUp className="w-6 h-6 mb-4 text-white/80" data-id="element-204" />
          <h3 className="text-4xl font-bold mb-1" data-id="element-205">0</h3>
          <p className="text-orange-100 text-sm" data-id="element-206">Workouts</p>
        </div>
        <div className="bg-gradient-to-br from-blue-500 to-cyan-500 rounded-2xl p-6 text-white shadow-lg shadow-blue-200" data-id="element-207">
          <Timer className="w-6 h-6 mb-4 text-white/80" data-id="element-208" />
          <h3 className="text-4xl font-bold mb-1" data-id="element-209">0</h3>
          <p className="text-blue-100 text-sm" data-id="element-210">Total Min</p>
        </div>
        <div className="bg-gradient-to-br from-amber-500 to-orange-500 rounded-2xl p-6 text-white shadow-lg shadow-amber-200" data-id="element-211">
          <Flame className="w-6 h-6 mb-4 text-white/80" data-id="element-212" />
          <h3 className="text-4xl font-bold mb-1" data-id="element-213">0</h3>
          <p className="text-amber-100 text-sm" data-id="element-214">Calories</p>
        </div>
      </div>

      {/* Chart Section */}
      <div className="bg-white rounded-2xl p-8 border border-slate-100 shadow-sm" data-id="element-215">
        <div className="flex justify-between items-center mb-8" data-id="element-216">
          <h3 className="font-bold text-lg text-slate-900" data-id="element-217">This Week</h3>
        </div>

        <div className="h-64 w-full" data-id="element-218">
          <ResponsiveContainer width="100%" height="100%" data-id="element-219">
            <BarChart data={data} data-id="element-220">
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" data-id="element-221" />
              <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
              fill: '#94a3b8',
              fontSize: 12
            }} dy={10} data-id="element-222" />
              <YAxis axisLine={false} tickLine={false} tick={{
              fill: '#94a3b8',
              fontSize: 12
            }} data-id="element-223" />
              <Tooltip cursor={{
              fill: '#f8fafc'
            }} contentStyle={{
              borderRadius: '8px',
              border: 'none',
              boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
            }} data-id="element-224" />
              <Bar dataKey="minutes" radius={[4, 4, 0, 0]} data-id="element-225">
                {data.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.minutes > 0 ? '#cbd5e1' : '#e2e8f0'} data-id="element-226" />)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Time Filter Tabs */}
      <div className="flex gap-2" data-id="element-227">
        <button className="px-4 py-2 bg-slate-800 text-white rounded-lg text-sm font-medium" data-id="element-228">
          This Week
        </button>
        <button className="px-4 py-2 bg-white border border-slate-200 text-slate-600 hover:bg-slate-50 rounded-lg text-sm font-medium transition-colors" data-id="element-229">
          This Month
        </button>
        <button className="px-4 py-2 bg-white border border-slate-200 text-slate-600 hover:bg-slate-50 rounded-lg text-sm font-medium transition-colors" data-id="element-230">
          All Time
        </button>
      </div>

      {/* Empty State */}
      <div className="flex flex-col items-center justify-center py-16 text-center" data-id="element-231">
        <div className="w-16 h-16 bg-slate-50 rounded-full flex items-center justify-center mb-4" data-id="element-232">
          <Activity className="w-8 h-8 text-slate-300" data-id="element-233" />
        </div>
        <h3 className="text-slate-900 font-medium mb-1" data-id="element-234">
          No exercises logged yet
        </h3>
        <p className="text-slate-500 text-sm mb-6" data-id="element-235">
          Start tracking your workouts to see your progress
        </p>
        <button className="bg-slate-800 hover:bg-slate-900 text-white px-6 py-2.5 rounded-lg text-sm font-medium transition-colors" data-id="element-236">
          Log Your First Workout
        </button>
      </div>
    </div>;
}